module.exports = __webpack_public_path__ + "img/recart-1.d6a0ce6e.jpg";